<template>
  <Container>
    <template v-slot:header>Credit Drift</template>

    <template v-slot:content>
      <div class="bg-white shadow rounded-lg p-6 w-full">
        <p class="text-sm text-gray-500">
          Accounts whose credit pack total (what the dashboard shows) differs
          from their real balance, largest gap first. Open an account and use
          the Credit Sync tab to fix it.
        </p>

        <p v-if="loading" class="mt-6 text-sm text-gray-500">Loading…</p>
        <p v-else-if="!rows.length" class="mt-6 text-sm text-gray-500">
          No drift found.
        </p>
        <div v-else class="mt-6 overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200 text-sm">
            <thead>
              <tr class="text-left text-gray-500">
                <th class="py-2 pr-4 font-medium">User</th>
                <th class="py-2 pr-4 font-medium">Account</th>
                <th class="py-2 pr-4 font-medium text-right">Packs</th>
                <th class="py-2 pr-4 font-medium text-right">Balance</th>
                <th class="py-2 font-medium text-right">Gap</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100">
              <tr
                v-for="row in rows"
                :key="`${row.account}-${row.user_id}`"
                class="cursor-pointer hover:bg-gray-50"
                role="link"
                tabindex="0"
                @click="openUser(row.user_id)"
                @keydown.enter="openUser(row.user_id)"
                @keydown.space.prevent="openUser(row.user_id)"
              >
                <td class="py-2 pr-4">{{ row.email || `#${row.user_id}` }}</td>
                <td class="py-2 pr-4">
                  {{
                    row.account === "organization" ? "Organization" : "Sub-user"
                  }}
                </td>
                <td class="py-2 pr-4 text-right">
                  {{ format(row.pack_total) }}
                </td>
                <td class="py-2 pr-4 text-right">{{ format(row.balance) }}</td>
                <td
                  :class="[
                    'py-2 text-right font-medium',
                    row.gap > 0 ? 'text-red-600' : 'text-yellow-700',
                  ]"
                >
                  {{ row.gap > 0 ? "+" : "" }}{{ format(row.gap) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
  </Container>
</template>
<script>
import { ref } from "vue";
import humanize from "humanize";
import Container from "@/components/common/Container";
import formMixin from "@/mixins/formMixin";

export default {
  name: "CreditDrift",
  mixins: [formMixin],
  components: { Container },
  setup() {
    return { rows: ref([]), loading: ref(true) };
  },
  async mounted() {
    const response = await this.handleSubmissionErrors(
      () => this.$alfredService.adminCreditDrift(),
      {}
    );
    this.rows = response?.results || [];
    this.loading = false;
  },
  methods: {
    format(value) {
      return humanize.numberFormat(value, 0);
    },
    openUser(userId) {
      if (userId) {
        this.$router.push({ name: "UserDetails", params: { userId } });
      }
    },
  },
};
</script>
